type JsonRecord = Record<string, unknown>;

const isRecord = (value: unknown): value is JsonRecord =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const hasPathBoundaryPrefix = (path: string, prefix: string): boolean =>
  path === prefix || path.startsWith(`${prefix}/`);

/** Parse the env-owned public portal registry without guessing a tenant. */
export const parseUnifiedPortalPaths = (raw: unknown): Record<string, string> => {
  if (typeof raw !== 'string' || raw.trim() === '') return {};
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return {};
  }
  if (!isRecord(parsed)) return {};

  const registry: Record<string, string> = {};
  for (const [site, prefix] of Object.entries(parsed)) {
    const sitePrefix = `/${site}`;
    if (
      !/^[a-z0-9][a-z0-9-]{0,63}$/.test(site) ||
      typeof prefix !== 'string' ||
      prefix === '' ||
      !prefix.startsWith('/') ||
      prefix.startsWith('//') ||
      prefix.includes('\\') ||
      /[\u0000-\u001f\u007f?#]/.test(prefix) ||
      /(?:^|\/)\.\.?(?:\/|$)/.test(prefix) ||
      !hasPathBoundaryPrefix(prefix, sitePrefix) ||
      ['admin', 'massager', 'main', 'checkin', 'sso'].some(segment =>
        hasPathBoundaryPrefix(prefix, `${sitePrefix}/${segment}`)
      ) ||
      prefix === `${sitePrefix}/login`
    ) {
      continue;
    }
    registry[site] = prefix;
  }
  return registry;
};
